import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const PageHeader = ({ eyebrow, title, subtitle, testid }) => (
  <section
    className="relative overflow-hidden bg-navy py-16 sm:py-20"
    data-testid={testid}
  >
    <div className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #D9A441 0, transparent 40%), radial-gradient(circle at 80% 60%, #D61F26 0, transparent 45%)" }} />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <nav className="mb-4 flex items-center gap-1.5 text-xs font-semibold text-white/60" aria-label="Breadcrumb">
          <Link to="/" className="transition-colors hover:text-gold" data-testid="breadcrumb-home">Home</Link>
          <ChevronRight size={13} />
          <span className="text-gold">{title}</span>
        </nav>
        {eyebrow && (
          <span className="text-sm font-semibold uppercase tracking-widest text-gold">{eyebrow}</span>
        )}
        <h1 className="mt-2 font-display text-4xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/70">{subtitle}</p>
        )}
      </Reveal>
    </div>
  </section>
);
